// Argon Dashboard 2 PRO MUI components
import ArgonBox from 'component/Argon/ArgonBox';

const sidenav_admin = [
  {
    type: 'collapse',
    name: 'จัดการสมาชิก',
    key: 'admin/user',
    route: '/admin/user',
    icon: <ArgonBox component="i" color="primary" fontSize="14px" className="ni ni-app" />,
    noCollapse: true,
  },
  {
    type: 'collapse',
    name: 'รายงานการสั่งซื้อ',
    key: 'admin/report',
    route: '/admin/report',
    icon: <ArgonBox component="i" color="primary" fontSize="14px" className="ni ni-app" />,
    noCollapse: true,
  },
  // {
  //   type: 'collapse',
  //   name: 'จัดการรายการสั่งซื้อ',
  //   key: 'admin/order',
  //   route: '/admin/order',
  //   icon: <ArgonBox component="i" color="primary" fontSize="14px" className="ni ni-app" />,
  //   noCollapse: true,
  // },
  // {
  //   type: 'collapse',
  //   name: 'รายการสั่งซื้อโดยผู้ดูแล',
  //   key: 'admin/order-admin',
  //   route: '/admin/order-admin',
  //   icon: <ArgonBox component="i" color="primary" fontSize="14px" className="ni ni-app" />,
  //   noCollapse: true,
  // },
  // {
  //   type: 'collapse',
  //   name: 'รายการสั่งซื้อโดยสมาชิก',
  //   key: 'admin/order-member',
  //   route: '/admin/order-member',
  //   icon: <ArgonBox component="i" color="primary" fontSize="14px" className="ni ni-app" />,
  //   noCollapse: true,
  // },
  // {
  //   type: 'collapse',
  //   name: 'รายการสั่งซื้อด้วย qr',
  //   key: 'admin/order-rapid',
  //   route: '/admin/order-rapid',
  //   icon: <ArgonBox component="i" color="primary" fontSize="14px" className="ni ni-app" />,
  //   noCollapse: true,
  // },
];

export default sidenav_admin;
